import {
  LOADING_SUBSCRIPTION_PLANS,
  LOAD_SUBSCRIPTION_PLANS,
  LOAD_SUBSCRIPTION_PLANS_ERROR,
  LOAD_ANNUAL_SUBSCRIPTION_PLANS,
  LOAD_ANNUAL_SUBSCRIPTION_PLANS_ERROR,
  TOGGLE_TERMS_MODAL,
  TOGGLE_PAY_TERMS,
  FETCH_TERMS_OF_BUSINESS,
  FETCH_TERMS_OF_BUSINESS_ERROR,
} from "../actions/types";

const initialState = {
  loading: true,
  termsModalLoading: true,
  termsModalActive: false,
  planToPayFor: null,
  payTermsAgreed: false,
  termsData: null,
  monthly: null,
  termsMonthly: null,
  termsOfBusiness: null,
  errors: {},
};

export default function subscriptionPlansReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOADING_SUBSCRIPTION_PLANS:
      return {
        ...state,
        loading: true,
      };
    case LOAD_SUBSCRIPTION_PLANS:
      return {
        ...state,
        loading: false,
        monthly: payload.monthly,
        termsMonthly: payload.termsMonthly,
        errors: {},
      };
    case LOAD_SUBSCRIPTION_PLANS_ERROR:
      return {
        ...state,
        loading: false,
        monthly: null,
        termsMonthly: null,
        errors: payload,
      };
    case LOAD_ANNUAL_SUBSCRIPTION_PLANS:
      return {
        ...state,
        ...payload,
        loading: false,
        errors: {},
      };
    case LOAD_ANNUAL_SUBSCRIPTION_PLANS_ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
      };
    case TOGGLE_TERMS_MODAL:
      return {
        ...state,
        termsModalActive: !state.termsModalActive,
      };
    case FETCH_TERMS_OF_BUSINESS:
      return {
        ...state,
        termsOfBusiness: payload,
        termsModalLoading: false,
        errors: {},
      };
    case FETCH_TERMS_OF_BUSINESS_ERROR:
      return {
        ...state,
        termsOfBusiness: null,
        termsModalLoading: false,
        errors: payload,
      };
    case TOGGLE_PAY_TERMS:
      return {
        ...state,
        payTermsAgreed: !state.payTermsAgreed,
      };
    default:
      return state;
  }
}
